export enum MembershipProductType {

    Unspecified = 0,
    MembershipType = 1,
    Addon = 2
}
